module.exports = __webpack_public_path__ + "media/make3.24d4e330.mp4";